import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#E15A28', // Primary orange from brand guide
      light: '#FF5A3A',
      dark: '#B94227',
      contrastText: '#fff',
    },
    secondary: {
      main: '#B94227', // Secondary darker orange
      light: '#E54B2D',
      dark: '#B93921',
      contrastText: '#fff',
    },
    success: {
      main: '#B0202F', // WINE accent from brand guide
      light: '#FFCAD2',
      dark: '#800F1C',
      contrastText: '#fff',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#4A4A4A',
      secondary: '#6E6E6E',
    },
    action: {
      active: '#DF643A',
      hover: '#D8A99C',
    },
  },
  typography: {
    fontFamily: '"Montserrat", sans-serif',
    h1: {
      fontFamily: '"Gaston CP", serif',
      fontWeight: 700,
      color: '#4A4A4A',
    },
    h2: {
      fontFamily: '"Gaston CP", serif',
      fontWeight: 700,
      color: '#4A4A4A',
    },
    h3: {
      fontFamily: '"Gaston CP", serif',
      fontWeight: 700,
      color: '#4A4A4A',
    },
    h4: {
      fontFamily: '"Gaston CP", serif',
      fontWeight: 700,
      color: '#4A4A4A',
    },
    h5: {
      fontFamily: '"Gaston CP", serif',
      fontWeight: 700,
      color: '#4A4A4A',
    },
    h6: {
      fontFamily: '"Gaston CP", serif',
      fontWeight: 700,
      color: '#4A4A4A',
    },
    subtitle1: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
    },
    subtitle2: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
    },
    body1: {
      fontFamily: '"Montserrat", sans-serif',
      color: '#6E6E6E',
    },
    body2: {
      fontFamily: '"Montserrat", sans-serif',
      color: '#6E6E6E',
    },
    button: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Gaston CP';
          font-style: normal;
          font-weight: 400;
          src: local('Gaston CP'), url('/fonts/GastonCP-Regular.woff2') format('woff2');
        }
        @font-face {
          font-family: 'Gaston CP';
          font-style: normal;
          font-weight: 700;
          src: local('Gaston CP Bold'), url('/fonts/GastonCP-Bold.woff2') format('woff2');
        }
      `,
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          padding: '10px 24px',
          fontSize: '1rem',
          fontWeight: 500,
        },
        containedPrimary: {
          backgroundColor: '#B0202F',
          '&:hover': {
            backgroundColor: '#80171E',
          },
        },
      },
    },
  },
});

export default theme;
